import type {
  CommissionConfig,
  ResetAllCommissionsResponse,
  UpdateAgentCommissionPayload,
  UpdateDefaultCommissionPayload,
} from "@/types/commission";
import { apiClient } from "./client";

export const commissionsApi = {
  getConfig() {
    return apiClient.get<CommissionConfig>("/admin/commissions");
  },

  updateDefault(payload: UpdateDefaultCommissionPayload) {
    return apiClient.put<CommissionConfig>(
      "/admin/commissions/default",
      payload,
    );
  },

  updateAgent(agentId: string, payload: UpdateAgentCommissionPayload) {
    return apiClient.put<CommissionConfig>(
      `/admin/commissions/agents/${agentId}`,
      payload,
    );
  },

  resetAll() {
    return apiClient.post<ResetAllCommissionsResponse>(
      "/admin/commissions/reset",
    );
  },
};
